"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectVektorioProject = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ApiKeyForm_1 = require("./components/ApiKeyForm");
var VektorioProjects_1 = require("./components/VektorioProjects");
var ConnectedProjects_1 = require("./components/ConnectedProjects");
var StatusBox_1 = require("./components/StatusBox");
var dispatchers_1 = require("./utils/dispatchers");
require("./index.scss");
var getConnectState = function (state) { return state.vektorio.connect; };
var ConnectVektorioProject = function (props) {
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var _a = React.useState(''), apiKey = _a[0], setApiKey = _a[1];
    var connectState = (0, react_redux_1.useSelector)(getConnectState);
    var PiggyBank = React.createElement(sok_ui_1.Icon, { className: 'fa-piggy-bank' });
    var CloseIcon = React.createElement(sok_ui_1.Icon, { className: 'fa-times-circle' });
    var linkProjects = function () {
        return dispatchers.linkProjects({
            project: props.currentProject,
            body: {
                apiKey: apiKey,
                vektorioIds: connectState.selectedProjects.map(function (project) { return project.vektorioId; })
            }
        });
    };
    var connectButtonDisabled = connectState.selectedProjects.length === 0;
    React.useEffect(function () {
        if (connectState.modalIsOpen === false) {
            dispatchers.clear();
        }
    }, [connectState.modalIsOpen]);
    var closeModalAndClear = function () {
        setApiKey('');
        props.closeModal();
    };
    return (React.createElement(sok_ui_1.Modal, { isOpen: connectState.modalIsOpen, className: 'vektorio-connect-projects-modal' },
        React.createElement(sok_ui_1.Header, { onClose: closeModalAndClear }, (0, translation_1.getLocalization)('vektorio/connectProjects')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement(StatusBox_1.StatusBox, { status: connectState.connectProjectStatus, prefix: 'vektorio/connect/project/status' }),
            React.createElement(StatusBox_1.StatusBox, { status: connectState.disconnectProjectStatus, prefix: 'vektorio/disconnect/project/status' }),
            React.createElement(StatusBox_1.StatusBox, { status: connectState.linkableProjectsStatus, prefix: 'vektorio/list/project/status' }),
            React.createElement(ApiKeyForm_1.ApiKeyForm, { apiKey: apiKey, setApiKey: setApiKey }),
            React.createElement(VektorioProjects_1.VektorioProjects, null),
            React.createElement(ConnectedProjects_1.ConnectedProjects, { currentProject: props.currentProject, fetch: dispatchers.fetchProjects(props.currentProject) })),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'green', iconRight: PiggyBank, disabled: connectButtonDisabled, onClick: linkProjects }, (0, translation_1.getLocalization)('vektorio/connect')),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', iconRight: CloseIcon, onClick: closeModalAndClear }, (0, translation_1.getLocalization)('buttons/close')))));
};
exports.ConnectVektorioProject = ConnectVektorioProject;
